import React from "react";
import {Grid, Skeleton} from "@mui/material";
import styled from "styled-components";
import Container from "@mui/material/Container";

const ROWS = 4;

const AspectRatioWrapper = styled.div`
    height: 10rem;
    position: relative;
`;

const ContentInside = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 8px;
    overflow: hidden;
`;


const BlogsSkeleton = ({showTitleSkeleton}) => {
    return (
        <Container maxWidth="xl">
            {showTitleSkeleton ? <Skeleton width={200} height={50}/> : <div/>}
            <Grid container spacing={2} style={{paddingLeft: 16, paddingRight: 16}}>
                {Array.from(new Array(ROWS)).map((_, index) => (
                    <Grid item key={index} xs={12} sm={4} md={4} lg={3}>
                        <AspectRatioWrapper>
                            <ContentInside>
                                <Skeleton variant="rectangular" width="100%" height="100%"
                                          sx={{borderRadius: '12px'}}/>
                            </ContentInside>
                        </AspectRatioWrapper>
                    </Grid>
                ))}

            </Grid>
        </Container>
    );
};

export default BlogsSkeleton;